module.exports = __webpack_public_path__ + "static/media/intro.a6f7317c.mp3";